'use strict';

var Bacon, MemoryStorage, R, _data, _storage, delegate;

Bacon = require('baconjs');

R = require('ramda');

_data = {};

MemoryStorage = {
  getItem: function getItem(svc, name) {
    return Bacon.once(_data[name]);
  },
  setItem: function setItem(svc, name, value) {
    return Bacon.once(_data[name] = value);
  },
  deleteItem: function deleteItem(svc, name) {
    return Bacon.once(_data = R.without(name, _data));
  }
};

_storage = MemoryStorage;

delegate = function delegate(impl, fnName, fallbackFn) {
  if (impl[fnName]) {
    return impl[fnName];
  } else {
    return impl[fallbackFn];
  }
};

module.exports = {
  getItem: R.curry(function (svc, name) {
    return delegate(_storage, 'getItem', 'getItem')(svc, name);
  }),
  getItemLT: R.curry(function (svc, name) {
    return delegate(_storage, 'getItemLT', 'getItem')(svc, name);
  }),
  setItem: R.curry(function (svc, name, value) {
    return delegate(_storage, 'setItem', 'setItem')(svc, name, value);
  }),
  setItemLT: R.curry(function (svc, name, value) {
    return delegate(_storage, 'setItemLT', 'setItem')(svc, name, value);
  }),
  deleteItem: R.curry(function (svc, name) {
    return delegate(_storage, 'deleteItem', 'deleteItem')(svc, name);
  }),
  deleteItemLT: R.curry(function (svc, name) {
    return delegate(_storage, 'deleteItemLT', 'deleteItem')(svc, name);
  }),
  setImpl: function setImpl(storageImpl) {
    return _storage = storageImpl;
  }
};